/* ============================================================
   SST — Collection sort
   Native <select> reloads the page with ?sort_by=<value>,
   preserving existing query params (filters, search terms).
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-sst-sort-select]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });
})();
